'use client'

import type { PayloadAdminBarProps } from '@payloadcms/admin-bar'

import { cn } from '@/utilities/cn'
import { useRouter, useSelectedLayoutSegments } from 'next/navigation'
import { PayloadAdminBar } from '@payloadcms/admin-bar'
import React, { useEffect, useState } from 'react'
import { useAuth } from '@/providers/Auth'

const collectionLabels = {
  posts: {
    plural: 'Posts',
    singular: 'Post',
  },
  projects: {
    plural: 'Projects',
    singular: 'Project',
  },
}

const Title: React.FC = () => <span>Dashboard</span>

export const AdminBar: React.FC<{
  adminBarProps?: PayloadAdminBarProps
}> = (props) => {
  const { adminBarProps } = props || {}
  const segments = useSelectedLayoutSegments()
  const router = useRouter()
  const [hasCMSUser, setHasCMSUser] = useState(false)
  const { logout, user } = useAuth()
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - todo fix, not sure why this is erroring
  const collection = collectionLabels?.[segments?.[1]] ? segments?.[1] : 'pages'
  const isFrontendAdmin = Boolean(user?.roles?.includes('admin'))
  const adminBarKey = isFrontendAdmin ? `admin-${user?.id ?? 'unknown'}` : 'guest'

  const onAuthChange = React.useCallback((cmsUser: { id?: string | number } | null | undefined) => {
    setHasCMSUser(Boolean(cmsUser))
  }, [])

  const handleLogoutClick = React.useCallback<NonNullable<PayloadAdminBarProps['logoutProps']>['onClick']>(
    async (event) => {
      event.preventDefault()

      try {
        await logout()
        setHasCMSUser(false)
        router.push('/')
        router.refresh()
      } catch (error) {
        console.error('Admin logout failed', error)
      }
    },
    [logout, router],
  )

  useEffect(() => {
    if (!isFrontendAdmin) {
      setHasCMSUser(false)
    }
  }, [isFrontendAdmin])

  return (
    <div
      className={cn('py-2 bg-black text-white', {
        block: hasCMSUser && isFrontendAdmin,
        hidden: !hasCMSUser || !isFrontendAdmin,
      })}
    >
      <div className="container">
        <PayloadAdminBar
          {...adminBarProps}
          key={adminBarKey}
          className="py-2 text-white"
          classNames={{
            controls: 'font-medium text-white',
            logo: 'text-white',
            user: 'text-white',
          }}
          cmsURL={process.env.NEXT_PUBLIC_SERVER_URL}
          collectionLabels={{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - todo fix, not sure why this is erroring
            plural: collectionLabels[collection]?.plural || 'Pages',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - todo fix, not sure why this is erroring
            singular: collectionLabels[collection]?.singular || 'Page',
          }}
          logo={<Title />}
          logoutProps={{
            onClick: handleLogoutClick,
            target: '_self',
          }}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - todo fix, not sure why this is erroring
          onAuthChange={onAuthChange}
          style={{
            backgroundColor: 'transparent',
            padding: 0,
            position: 'relative',
            zIndex: 'unset',
          }}
        />
      </div>
    </div>
  )
}
